import { Box } from "@mui/material";
import NavItem from "@/layout/header/navigation/nav-item";
import { BaseHeaderProps } from "@/layout/header";
import { Caption } from "@theme/components/typography.fontvariant";

interface DesktopNavigationProps {
  routes: BaseHeaderProps["routes"];
}

const DesktopNavigation = (props: DesktopNavigationProps) => {
    const { routes } = props;

    if (routes === undefined || routes.length === 0) {
        return;
    }

    return (
        <Box
            sx={{
                display: {
                xs: "none", // Hide on extra-small screens
                lg_xl: "flex", // Show on large and extra-large screens
                },
            }}
        >
            <NavItem data={routes.map(route => ({
                href: route.href ?? "", // Ensure href is always a string
                title: route.title,
                children: route.children
                    ?.filter(child => child.href) // Filter out children without href
                    .map(child => ({
                        href: child.href ?? "", // Ensure child href is always a string
                        title: child.title,
                        children: child.children?.map(grandChild => ({
                            href: grandChild.href ?? "", // Ensure grandchild href is always a string
                            title: grandChild.title,
                        })),
                    })),
            })).filter(route => route.href)} // Filter out routes without href
            />
        </Box>
    );
};

export default DesktopNavigation;
